import Contract from './Contract';
import abi from '../abi/toxic.json';

class Toxic extends Contract {
    constructor(options, address) {
        super(options, "Toxic", abi, address);
    }
}

export default Toxic;